export const ecommercePackages = [
  {
    id: 'shuru-shop',
    name: 'Shuru Shop',
    tagline: 'Kickstart your online store',
    price: 15000,
    currency: '৳',
    timeline: '10 - 15 days',
    accent: 'green',
    icon: 'bag',
    description:
      'A clean, fully functional ecommerce store for small businesses ready to start taking orders online with Cash on Delivery.',
    features: [
      'Unlimited products with search, sort & filter',
      'Fully mobile responsive storefront',
      'Cart & Cash on Delivery (COD) checkout',
      'Customer signup / login & order history',
      'Admin dashboard with basic inventory',
      'Customer reviews & ratings',
      'WhatsApp order button + basic SEO',
      'SSL setup & deployment',
      '10 days free bug support',
    ],
  },
  {
    id: 'bazaar-pro',
    name: 'Bazaar Pro',
    tagline: 'Sell smart with online payments',
    price: 22000,
    currency: '৳',
    timeline: '15 - 20 days',
    popular: true,
    accent: 'blue',
    icon: 'card',
    inherits: 'Shuru Shop',
    description:
      'Everything in Shuru Shop, plus local payment gateways, courier integration and marketing tracking to fully run your store.',
    features: [
      'bKash, Nagad & Rocket integration',
      'SSLCommerz payment gateway',
      'Courier API (Pathao / Steadfast / RedX)',
      'Coupon & discount system',
      'Advanced inventory with low-stock alerts',
      'Email + SMS order notifications',
      'Facebook Pixel + Google Analytics setup',
      'Role-based admin access',
      '1 months free bug support',
    ],
  },
  {
    id: 'mega-mart',
    name: 'Mega Mart',
    tagline: 'A full-blown ecommerce engine',
    price: 27000,
    currency: '৳',
    timeline: '25 - 30 days',
    accent: 'purple',
    icon: 'zap',
    inherits: 'Bazaar Pro',
    description:
      'A complete ecommerce suite with automation, marketing tools and analytics — built to scale with you as you grow.',
    features: [
      'Auto order dispatch + customer tracking page',
      'Advanced analytics dashboard',
      'Loyalty points & abandoned cart recovery',
      'Wishlist & product comparison',
      'PWA — installable on phone',
      'Multi-warehouse with stock transfer',
      'Sales reports & refund management',
      'Bulk product import / export',
      '2 months free bug support',
    ],
  },
  {
    id: 'shop-sultan',
    name: 'Shop Sultan',
    tagline: 'Enterprise grade. Built to rule.',
    price: 35000,
    currency: '৳',
    timeline: '30 - 40 days',
    accent: 'orange',
    icon: 'award',
    inherits: 'Mega Mart',
    description:
      'Multi-vendor marketplace and multi-branch commerce platform with deep reporting and POS-ready backend for serious operators.',
    features: [
      'Multi-vendor marketplace + commission system',
      'Multi-branch operations',
      'Multi-currency + Bangla & English UI',
      'Subscription & EMI checkout',
      'POS-ready backend',
      'Granular role-based access control + audit logs',
      'BI reporting + API access for 3rd party tools',
      'CDN + automated backups & priority fixes',
      '3 months free bug support',
    ],
  },
];

export const enterprisePackage = {
  id: 'custom-forge',
  name: 'Custom Forge',
  tagline: 'Built around your business',
  icon: 'settings',
  description:
    "Got something bigger in mind? Headless commerce, custom ERP / CRM integration, native mobile apps, dedicated infrastructure — let's scope it together.",
  features: [
    'Tailored requirements analysis',
    'Headless / decoupled architecture',
    'Native mobile app (Android & iOS)',
    'Custom ERP / CRM / accounting integrations',
    'Dedicated VPS / cloud setup (AWS / DO)',
    'Custom workflow automations',
    'Dedicated project manager + SLA support',
    'Ongoing maintenance + white-label setup',
  ],
};

export const pricingNote = {
  taxes:
    'All prices are in Bangladeshi Taka (৳) and are one-time project fees. Hosting, domain & 3rd party gateway fees are billed separately.',
  payment:
    'Payment: 40% advance, 30% after staging delivery, 30% after final delivery.',
};
